import PropTypes from 'prop-types';
import React from 'react';
import Loader from './loader.jsx';
import { routeToTerm } from '../actions/route';
import { fetchSection } from '../actions/section';
import sectionViewSelector from 'selectors/component_selectors/section_view_selector';
import hashHistory from '../history';

import connect from './connect';
import ManageContentMenu from './manage_content_menu.jsx';

class SectionView extends React.Component {
    static displayName = 'SectionView';

    static propTypes = {
        currentPath: PropTypes.string,
        routeToTerm: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        children: PropTypes.object,
        section: PropTypes.object,
        isInstructor: PropTypes.bool,
        params: PropTypes.shape({ sectionId: PropTypes.string }),
    };

    async componentDidMount() {
        const {
            section: { id },
            params: { sectionId },
            fetchSection,
        } = this.props;
        if (!id) {
            try {
                await fetchSection(sectionId);
            } catch (e) {
                hashHistory.push('/');
            }
        }
    }

    componentDidUpdate(oldProps) {
        const {
            section: { id, term_id },
            routeToTerm,
        } = this.props;
        id && routeToTerm({ termId: term_id });
    }

    renderManageContent() {
        if (this.props.isInstructor) {
            return (
                <div className="manage-content-container">
                    <div className="manage-content js-manage-content">
                        <ManageContentMenu
                            currentPath={this.props.currentPath}
                        />
                    </div>
                </div>
            );
        }
    }

    render() {
        return <Loader />;
    }
}

const mapStateToProps = sectionViewSelector;

export default connect(
    mapStateToProps,
    { routeToTerm, fetchSection }
)(SectionView);



// WEBPACK FOOTER //
// ./src/components/section_view.jsx